import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "X recusou seu convite para #canal."
 *
 * Vai para o dono e para quem convidou, para a recusa chegar como resposta.
 * O clique abre o canal, de onde se convida outra pessoa pela aba de membros.
 */
export default class ChannelInviteDeclinedNotification extends Notification {
  icon() {
    return 'fas fa-user-xmark';
  }
  href() {
    const channelId = this.data().channelId;
    return channelId ? app.route('chat.channel', {
      id: channelId
    }) : app.route('chat.index');
  }
  content() {
    var _this$data$channelNam;
    const decliner = this.attrs.notification.fromUser();
    return app.translator.trans('ramon-chat.forum.notifications.channel_invite_declined', {
      username: decliner ? decliner.displayName() : app.translator.trans('ramon-chat.forum.notifications.someone', {}, true),
      channel: (_this$data$channelNam = this.data().channelName) != null ? _this$data$channelNam : app.translator.trans('ramon-chat.forum.nav.chat', {}, true)
    });
  }
  excerpt() {
    return null;
  }
  data() {
    var _ref;
    return (_ref = this.attrs.notification.content()) != null ? _ref : {};
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChannelInviteDeclinedNotification', ChannelInviteDeclinedNotification);